import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../componentes/header/header";

function Dissertacoes() {
    return (
        <>
        <Helmet>
            <title>Anais de eventos cientifícos | SOBREVIDAS-ACS</title>
        </Helmet>,
        <Header/>,
        </>
    );
}
export default Dissertacoes